// Actions
const REQUEST_FORGOTTEN_CREDENTIALS         = 'zen/forgot/REQUEST_FORGOTTEN_CREDENTIALS';
const REQUEST_FORGOTTEN_CREDENTIALS_SUCCESS = 'zen/forgot/REQUEST_FORGOTTEN_CREDENTIALS_SUCCESS';
const REQUEST_FORGOTTEN_CREDENTIALS_FAIL    = 'zen/forgot/REQUEST_FORGOTTEN_CREDENTIALS_FAIL';
const HANDLE_RADIO_CHANGE                   = 'zen/forgot/HANDLE_RADIO_CHANGE';
const HANDLE_NEXT_BUTTON_CLICK              = 'zen/forgot/HANDLE_NEXT_BUTTON_CLICK';
const HANDLE_BACK_BUTTON_CLICK              = 'zen/forgot/HANDLE_BACK_BUTTON_CLICK';
const HANDLE_MODAL_CLOSE                    = 'zen/forgot/HANDLE_MODAL_CLOSE';
const HANDLE_EMAIL_INPUT_CHANGE             = 'zen/forgot/HANDLE_EMAIL_INPUT_CHANGE';
const HANDLE_SCREEN_RESIZE                  = 'zen/forgot/HANDLE_SCREEN_RESIZE';

// Exported Constants
const OPTION_FORGOT_USERNAME                = 'username';
const OPTION_FORGOT_PASSWORD                = 'password';

// State
const initialState = {
  selectedOption: OPTION_FORGOT_USERNAME,
  activeWizardStepIndex: 0,
  emailAddress: null,
  fetching: false,
  hasError: false,
  isMobileSize: (window.innerWidth < 768),
  message: null
};

// Reducer
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case REQUEST_FORGOTTEN_CREDENTIALS:
      return {
        ...state,
        fetching: true,
        hasError: false,
        message: null
      };
    case REQUEST_FORGOTTEN_CREDENTIALS_SUCCESS:
      return {
        ...state,
        fetching: false,
        hasError: false,
        activeWizardStepIndex: state.activeWizardStepIndex + 1
      };
    case REQUEST_FORGOTTEN_CREDENTIALS_FAIL:
      return {
        ...state,
        fetching: false,
        hasError: true,
        message: 'An error occurred. Please try again later.'
      };
    case HANDLE_RADIO_CHANGE:
      return {
        ...state,
        selectedOption: action.payload
      };
    case HANDLE_NEXT_BUTTON_CLICK:
      return {
        ...state,
        activeWizardStepIndex: state.activeWizardStepIndex + 1
      };
    case HANDLE_BACK_BUTTON_CLICK:
      return {
        ...state,
        activeWizardStepIndex: state.activeWizardStepIndex - 1
      };
    case HANDLE_EMAIL_INPUT_CHANGE:
      return {
        ...state,
        emailAddress: action.payload
      };
    case HANDLE_SCREEN_RESIZE:
      return {
        ...state,
        isMobileSize: action.payload
      };
    case HANDLE_MODAL_CLOSE:
      return initialState;
    default:
      return state;
  }
};

// Action Creators
const requestForgottenCredentials = (payload) => {
  return { type: REQUEST_FORGOTTEN_CREDENTIALS, payload };
};

const requestForgottenCredentialSuccess = () => {
  return { type: REQUEST_FORGOTTEN_CREDENTIALS_SUCCESS };
};

const requestForgottenCredentialFail = () => {
  return { type: REQUEST_FORGOTTEN_CREDENTIALS_FAIL };
};

const handleRadioChange = (e) => {
  return { type: HANDLE_RADIO_CHANGE, payload: e.target.name };
};

const handleNextButtonClick = () => {
  return { type: HANDLE_NEXT_BUTTON_CLICK };
};

const handleBackButtonClick = () => {
  return { type: HANDLE_BACK_BUTTON_CLICK };
};

const handleModalClose = () => {
  return { type: HANDLE_MODAL_CLOSE };
};

const handleEmailInputChange = (e) => {
  return { type: HANDLE_EMAIL_INPUT_CHANGE, payload: e.target.value };
};

const handleScreenResize = () => {
  return { type: HANDLE_SCREEN_RESIZE, payload: window.innerWidth < 768 };
};

// Exports
export default reducer;
export {
  // Actions
  REQUEST_FORGOTTEN_CREDENTIALS,
  REQUEST_FORGOTTEN_CREDENTIALS_SUCCESS,
  REQUEST_FORGOTTEN_CREDENTIALS_FAIL,
  HANDLE_MODAL_CLOSE,
  HANDLE_RADIO_CHANGE,
  HANDLE_NEXT_BUTTON_CLICK,
  HANDLE_BACK_BUTTON_CLICK,
  HANDLE_SCREEN_RESIZE,
  HANDLE_EMAIL_INPUT_CHANGE,

  // Exported Constants
  OPTION_FORGOT_USERNAME,
  OPTION_FORGOT_PASSWORD,

  // Action Creators
  requestForgottenCredentials,
  requestForgottenCredentialSuccess,
  requestForgottenCredentialFail,
  handleModalClose,
  handleRadioChange,
  handleNextButtonClick,
  handleBackButtonClick,
  handleScreenResize,
  handleEmailInputChange
};
